import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase';
import type { JSX, MouseEvent } from 'react';
import type { StateItemProps } from './types';

export const StateItem = ({
  state,
  isOpen,
  selected,
  query,
  onToggleExpand,
  onSelectDistrict,
}: StateItemProps): JSX.Element => {
  return (
    <Box key={state.id}>
      <ListItemButton onClick={(e: MouseEvent<HTMLDivElement>) => onToggleExpand(state.id, e)}>
        <ListItemIcon sx={{ minWidth: 32 }}>
          {isOpen ? <ExpandLess data-test="expand-less-icon" /> : <ExpandMore data-test="expand-more-icon" />}
        </ListItemIcon>

        <ListItemText
          primary={
            <Typography>
              <HighlightedPhrase searchPhrase={query}>{state.name}</HighlightedPhrase>
            </Typography>
          }
        />
      </ListItemButton>

      {isOpen && (
        <List disablePadding>
          {state.children?.map(district => {
            const isSelected = selected.has(district.id);

            return (
              <ListItemButton
                key={district.id}
                sx={{
                  pl: 7,
                  ...(isSelected && {
                    color: 'action.disabled',

                    '&:hover': {
                      backgroundColor: theme => alpha(theme.palette.common.black, 0.08),
                    },
                  }),
                }}
                onClick={() => onSelectDistrict(district)}
                data-test="congressional-district-item"
              >
                <ListItemText primary={<HighlightedPhrase searchPhrase={query}>{district.name}</HighlightedPhrase>} />
              </ListItemButton>
            );
          })}
        </List>
      )}
    </Box>
  );
};
